import { render, staticRenderFns } from "./SecondaryAccountsComp.vue?vue&type=template&id=1fe7b85c&scoped=true&"
import script from "./SecondaryAccountsComp.vue?vue&type=script&lang=ts&"
export * from "./SecondaryAccountsComp.vue?vue&type=script&lang=ts&"
import style0 from "./SecondaryAccountsComp.vue?vue&type=style&index=0&id=1fe7b85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7b85c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDialog,VFlex,VForm,VIcon,VLayout,VTextField})
